import { authLogout } from 'actions/AuthActions'
import { pushWithRegion } from 'actions/NavigationActions'
import LineSignoutIcon from 'LuxKit/Icons/line/LineSignoutIcon'
import { useAppDispatch } from 'hooks/reduxHooks'
import type { ComponentProps, MouseEventHandler } from 'react'
import React, { useCallback } from 'react'
import { useIntl } from 'react-intl'
import NavBarListItem from 'components/NavKit/NavBarListItem'
import NavBarListItemIcon from 'components/NavKit/NavBarListItemIcon'

type InheritedListItemProps = Pick<ComponentProps<typeof NavBarListItem>, 'onClick'>

function AccountMenuLogoutListItem({ onClick }: InheritedListItemProps) {
  const intl = useIntl()
  const dispatch = useAppDispatch()
  const handleClick = useCallback<MouseEventHandler<HTMLButtonElement>>((event) => {
    dispatch(authLogout())
    dispatch(pushWithRegion('/'))
    onClick?.(event)
  }, [onClick, dispatch])

  return <NavBarListItem
    startIcon={<NavBarListItemIcon Icon={LineSignoutIcon} />}
    title={intl.formatMessage({
      id: 'INU7G6+IG5',
      defaultMessage: 'Log out',
      description: 'Navigation item title for logout action in the navigation bar',
    })}
    onClick={handleClick}
  />
}

export default AccountMenuLogoutListItem
